export const isDev = (): boolean => !isProd();

export const isProd = (): boolean => {
  try {
    return ["prod", "production", "staging"].includes(
      process.env.GATSBY_VM_ENV
    );
  } catch {
    return false;
  }
};

export const isProductionAU: boolean =
  process.env.GATSBY_VM_ENV.toLowerCase() === "production" &&
  process.env.GATSBY_VM_MARKET.toUpperCase() === "AU";

export const isProduction: boolean =
  process.env.GATSBY_VM_ENV.toLowerCase() === "production";
